import { render, staticRenderFns } from "./CollapsiblePanelLasche.vue?vue&type=template&id=f4325be4&scoped=true&"
import script from "./CollapsiblePanelLasche.vue?vue&type=script&lang=js&"
export * from "./CollapsiblePanelLasche.vue?vue&type=script&lang=js&"
import style0 from "./CollapsiblePanelLasche.vue?vue&type=style&index=0&id=f4325be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4325be4",
  null
  
)

export default component.exports